import { useQueryClient } from '@tanstack/react-query'
import { leadDuplicateKey } from 'utils/constants/queryKey'
import { useAppQuery } from 'hooks/use-app-query'
import { checkLeadDuplicatesV2, getLeadDuplicatesList } from 'services/lead'
import {
  CheckLeadDuplicatesV2Payload,
  CheckLeadDuplicatesV2Response,
  GetLeadDuplicateListPayload,
  LeadDuplicateField,
} from 'services/types/lead'
import i18next from 'i18next'
import useAppMutation from 'hooks/use-app-mutation'

const useList = (payload: CheckLeadDuplicatesV2Payload) =>
  useAppQuery(leadDuplicateKey.list(payload), () => checkLeadDuplicatesV2(payload))

const useLeadDuplicateCheck = () => useAppMutation(leadDuplicateKey.list(), checkLeadDuplicatesV2)

const useInvalidate = () => {
  const queryClient = useQueryClient()
  const invalidateAllDuplicateList = () => queryClient.invalidateQueries(leadDuplicateKey.lists())
  return {
    invalidateAllDuplicateList,
  }
}

const useListPerLead = (payload: GetLeadDuplicateListPayload) =>
  useAppQuery(leadDuplicateKey.listPerLead(payload), () => getLeadDuplicatesList(payload))

export type LeadDuplicateReason = keyof CheckLeadDuplicatesV2Response['reasons']

export const mapDuplicateReason: (reason_name: LeadDuplicateReason) => string = (reason_name) => {
  switch (reason_name) {
    case 'email_address':
      return i18next.t('email_lbl').toLowerCase()
    case 'mobile':
      return i18next.t('mobile_number_lbl').toLowerCase()
    case 'full_name':
      return i18next.t('name_lbl').toLowerCase()
    case 'company_name':
      return i18next.t('company_name_lbl').toLowerCase()
    case 'reg_no':
      return i18next.t('reg_no_lbl').toLowerCase()
    case 'website':
      return i18next.t('website_lbl').toLowerCase()
    default:
      return reason_name
  }
}

export const mapDuplicateInfoField: (field: LeadDuplicateField) => string = (field) => {
  switch (field) {
    case 'email_address':
      return i18next.t('contact_email_lbl')
    case 'email_domain':
      return i18next.t('contact_email_domain_lbl')
    case 'email_alias':
      return i18next.t('contact_email_alias_lbl')
    case 'mobile':
      return i18next.t('contact_mobile_number_lbl')
    case 'full_name':
      return i18next.t('contact_name_lbl')
    case 'company_name':
      return i18next.t('company_name_lbl')
    case 'reg_no':
      return i18next.t('company_reg_no_lbl')
    case 'website':
      return i18next.t('company_website_lbl')
    default:
      return field
  }
}

export default {
  useList,
  useListPerLead,
  useInvalidate,
  useLeadDuplicateCheck,
}
